module.exports = __webpack_public_path__ + "static/08-7f40462ad9ec3098c28e69750263a11c.jpg";